export default __webpack_public_path__ + "static/dont-stack-e1b2adbc52394c2b7692021527020b67.png";